import { Box, Image, Stack, Text } from "@chakra-ui/core";
import React from "react";
import jwtService from "../api/jwt.service";
import useAuth from "../context/AuthContext";
import { useWindowDimensions } from "../lib/utils/hooks";
import styles from "./Hero.module.css";

const Hero = (props) => {
  const { width } = useWindowDimensions();
  const {
    state: { isLowBandwidth },
  } = useAuth();

  const isMobile = width <= 700;

  React.useEffect(() => {}, []);

  return (
    <Box position="relative" height={["30vh", "67vh"]} mt="180px" mx="auto">
      {isLowBandwidth ? (
        <Box
          w="100%"
          h="100%"
          bg="#eee"
          d="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Text color="#ccc">Low Bandwidth Mode</Text>
        </Box>
      ) : (
        <Image
          id="will-hide"
          h="100%"
          width="100vw"
          objectFit={props.size || "cover"}
          objectPosition={props.position || "10 60%"}
          src={props.heroImage}
        />
      )}

      <Box
        className={
          (props.heroHeading || props.heroSub) &&
          !isLowBandwidth &&
          styles.Overlay
        }
        position="absolute"
        left="0px"
        w="100%"
        h={["50%", props.headerHeight]}
        bottom="0px"
        left="0px"
        zIndex="200"
        color="white"
      >
        {!isLowBandwidth && (
          <Stack mt={["0", "10"]} mb={["6", "0"]} ml={["10", "40"]}>
            <Text>{props.heroHeading}</Text>
            <Text
              fontWeight="700"
              fontSize={["xl", "4xl"]}
              w={["75%", "35%"]}
              fontFamily="Familiar Pro"
              lineHeight="shorter"
              mb="10"
            >
              {props.heroSub}
            </Text>
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default Hero;
